import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const GettingStartedIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M1.99994 12.0004C1.99994 6.47752 6.47709 2.00037 11.9999 2.00037C17.5228 2.00037 21.9999 6.47752 21.9999 12.0004C21.9999 17.5232 17.5228 22.0004 11.9999 22.0004C6.47709 22.0004 1.99994 17.5232 1.99994 12.0004ZM16.707 10.2074L11.707 15.2074C11.3165 15.5979 10.6833 15.5979 10.2928 15.2074L6.79279 11.7074L8.207 10.2932L10.9999 13.0861L15.2928 8.79321L16.707 10.2074Z'
          fill={color} />
  </svg>
)

export default GettingStartedIcon
